/* eslint-disable no-dupe-keys */
import React from "react";
import { useState, useEffect } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../components/style.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import No_image from "../img/No_Image.jpg";
import Swal from "sweetalert2";
import LoadingPage from "../components/LoadingPage";
import jwt from "jsonwebtoken";
import {
  checkGroupsUser,
  getlocalStorage,
  handleResizeDisplay,
  thai_date,
  maskIDNumber,
} from "../function/functionALL";
import Layout from "../components/Layout";

require("moment/locale/th");

const PageEditUserData = () => {
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const location = useLocation();
  const { idUser, search, pageNumber, AmountPage } = location.state;
  const navigate = useNavigate();
  const [DataUser, setDataUser] = useState([]);
  const [loadingpage, setLoadingpage] = useState(true);
  const [imageUrl, setimageUrl] = useState([]);

  useEffect(() => {
    fetchUserData();
  }, [DataUser.air_worker]);

  const fetchUserData = async () => {
    try {
      const response = await Axios.get(
        process.env.REACT_APP_API_USERS + `${idUser}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );

      setDataUser(response.data);
      // const imageUrlHTTPS = response.data.image.replace(/^http:/, 'https:');
      // setimageUrl(imageUrlHTTPS);
      if (response.data.image) {
        const imageUrlHTTPS = response.data.image.replace(/^http:/, "https:");
        setimageUrl(imageUrlHTTPS);
      } else {
        setimageUrl(null);
      }
      setLoadingpage(false);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      } else {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เรียกข้อมูลไม่สำเร็จ",
        });
      }
    }
  };

  const handleAbsent = (e) => {
    const updatedReason = e.target.value;

    Axios.patch(
      process.env.REACT_APP_API_USERS + `${idUser}/`,
      {
        air_worker: updatedReason,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ!",
        });
        fetchUserData();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        Swal.fire({
          icon: "error",
          title: "แก้ไขข้อมูลไม่สำเร็จ",
        });
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  //upload img
  // const [selectedImage, setSelectedImage] = useState(null);

  // const handleFormSubmit = async (event) => {
  //     event.preventDefault();

  //     if (selectedImage) {
  //         const formData = new FormData();
  //         formData.append('image', selectedImage);

  //         try {
  //             const response = await Axios.patch(process.env.REACT_APP_API_USERS + `${idUser}/upload_image/`, formData, {

  //                 headers: {
  //                     Authorization: "Token " + DataLogin.token,
  //                 }
  //             });

  //             if (response.status === 200) {

  //                 navigate(0);
  //             } else {
  //                 console.error('Image upload failed.');
  //             }
  //         } catch (error) {
  //             if (error.response.status === 401) {
  //                 localStorage.removeItem("DataLogin");
  //                 navigate('/notfound404',
  //                     // { state: {statusCode: err.response.status, txt: err.response.data} }
  //                 )
  //             }
  //             console.error(error);
  //         }
  //     }
  // };

  // const [imagePreview, setImagePreview] = useState(null);
  // const handleImageChange = (event) => {
  //     const file = event.target.files[0];
  //     setSelectedImage(file);

  //     // Create a preview URL for the selected image
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //         setImagePreview(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  // };

  return (
    <>
      <Layout>
        {loadingpage ? (
          <LoadingPage />
        ) : (
          <div>
            <Form>
              <div className="App login-box">
                <section
                  style={{
                    backgroundImage: `url(${bg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    backgroundSize: "cover",
                    minHeight: "1024px",
                  }}
                >
                  <div
                    className="mb-0 rounded"
                    style={{ padding: "68px 0 0 0" }}
                  >
                    <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3 ">
                      <div className="p-3 d-flex justify-content-center">
                        <div className="shadow-lg rounded col-sm-12 col-xs-12 col-lg-10 ">
                          <div className="card-body rounded">
                            <div className=" row d-flex p-2">
                              <div className=" col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3 d-flex p-0 mt-2">
                                <div className="col-3 col-sm-3 text-start">
                                  <Link
                                    to={`/PageManageUser`}
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                      display: "inline-block",
                                    }}
                                    state={{
                                      props_search: search,
                                      props_pageNumber: pageNumber,
                                      props_AmountPage: AmountPage,
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-primary m-0 d-none d-md-block px-4 "
                                      style={{
                                        backgroundColor:
                                          "rgb(2, 117, 216,0.80)",
                                        border: "none",
                                      }}
                                    >
                                      ย้อนกลับ
                                    </button>
                                  </Link>
                                  <Link
                                    to={`/PageManageUser`}
                                    state={{
                                      props_search: search,
                                      props_pageNumber: pageNumber,
                                      props_AmountPage: AmountPage,
                                    }}
                                    className="d-md-none"
                                  >
                                    <FaArrowAltCircleLeft
                                      style={{
                                        fontSize: "22px",
                                        color: "#3399FF",
                                      }}
                                      className="mt-2"
                                    />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-sm-12 text-center fw-bold mb-3"
                              style={{ fontSize: "21px", color: "#000000" }}
                            >
                              ข้อมูลสมาชิก
                            </div>

                            <hr></hr>
                            <div className="row px-1 d-flex flex-row justify-content-center">
                              <div className="p-3 col-12 col-md-4 col-lg-4 text-center align-items-center">
                                <div className="mt-1">
                                  {imageUrl !== null ? (
                                    <img
                                      src={imageUrl}
                                      alt="Profile"
                                      className="rounded img-fluid"
                                      style={{ maxHeight: "220px" }}
                                    />
                                  ) : (
                                    <img
                                      src={No_image}
                                      alt="Profile"
                                      className="rounded img-fluid"
                                      style={{ maxHeight: "220px" }}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className=" p-1 col-12 col-md-6 col-lg-6 mb-2 d-flex align-items-center">
                                <div
                                  className="tab-pane fade show active profile-overview w-100 d-flex justify-content-center align-items-center"
                                  id="profile-overview"
                                >
                                  <div
                                    className="col-12 col-sm-8 col-md-12 col-lg-12 "
                                    style={{
                                      fontSize: "14px",
                                      color: "#000000",
                                    }}
                                  >
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex ">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold ">
                                        เลขประจำตัวประชาชน :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {maskIDNumber(DataUser.person_id)}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ชื่อ :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataUser.full_name}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ตำแหน่ง :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataUser.position}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12  col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        สังกัด :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataUser.unit}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ปฏิบัติหน้าที่ :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataUser.work_unit}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ปีเกิด :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {thai_date(DataUser.birthday, "year")}
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        เป็นผู้ปฏิบัติงาน :
                                      </div>
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 label">
                                        <input
                                          type="radio"
                                          name="reason"
                                          value="false"
                                          onChange={(e) => handleAbsent(e)}
                                          checked={
                                            DataUser.air_worker === false
                                          }
                                        />{" "}
                                        ภาคพื้น
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex mt-1">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold"></div>
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 label">
                                        <input
                                          type="radio"
                                          name="reason"
                                          value="true"
                                          onChange={(e) => handleAbsent(e)}
                                          checked={DataUser.air_worker === true}
                                        />{" "}
                                        ภาคอากาศ
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Form>
          </div>
        )}
      </Layout>
    </>
  );
};

export default PageEditUserData;
